import {Prompt, UserScope} from '@logto/browser';
import {LogtoAuthConfig} from '@ratespecial/logto-angular';
import {BILLING_PERMISSIONS} from 'src/app/shared/auth/billing-permissions';

const logto: LogtoAuthConfig = {
  endpoint: 'https://auth.rsdatatech.com',
  appId: 'hwm14ano2hdqi4mti9w2e',
  scopes: [UserScope.Email, UserScope.Profile, ...BILLING_PERMISSIONS],
  resources: ['https://api.billing.rsdatatech.com'],
  prompt: Prompt.Consent,
  routing: {
    callbackPath: '/auth/callback',
    signedOutPath: '/auth/signed-out',
    primaryResource: 'https://api.billing.rsdatatech.com',
    secureRoutes: [
      {resource: 'https://api.billing.rsdatatech.com', routes: ['/api']},
    ],
  },
};

export const environment = {
  production: true,

  // This is set during the build process, using replace-in-file package.  See pipelines for usage.
  release: 'ukbilling@--',

  logto,
};
